import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './LandingSection.scss';

export default function LandingSection({ children, className }) {
	return (
		<div className={classnames('landing-section', className)}>
			{children}
		</div>
	);
}

LandingSection.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string
};
